export const GET_GUIDES = "guides/GET_GUIDES";
export const GET_GUIDES_SUCCESS = "guides/GET_GUIDES_SUCCESS";
export const GET_GUIDES_ERROR = "guides/GET_GUIDES_ERROR";

export const UPDATE_GUIDES = "guides/UPDATE_GUIDES";
export const UPDATE_GUIDES_SUCCESS = "guides/UPDATE_GUIDES_SUCCESS";
export const UPDATE_GUIDES_ERROR = "guides/UPDATE_GUIDES_ERROR";